import doc                      from 'decorators/doc';
import model                    from 'decorators/model';
import { Timestampable }        from 'helpers/traits';
import { Blamable }             from 'helpers/traits';
import DirectoryPrivateApiModel from 'modelx/models/abstracts/DirectoryPrivateApiModel';

@model.cacheDuration()
@model.staticLabel('CompanyProperty')
@model.urnResource('company_property')
@doc.path('/company_properties/{?id}')
export default class CompanyPropertyModel extends Blamable(Timestampable(DirectoryPrivateApiModel)) {
	public _filters: ModelFiltersExtended<{
		'isUnique': '0' | '1';
		'reference': DirectoryCompanyPropertyReference;
		'type': id;
	}> = {};

	public _sorts: ModelSortsExtended<unknown> = {};

	@doc.boolean declare isUnique: boolean;
	@doc.string declare label: string;
	@doc.string declare reference: DirectoryCompanyPropertyReference;
	@doc.boolean declare unique: boolean;
	@doc.string declare type: string;
}